import { create } from "zustand";
import { AuthStore, UserStore } from "./types";
import { generateToken } from "apigateway/authorization";

export const useAuthStore = create<AuthStore>((set) => ({
  authToken: null,
  setAuthToken: (token: string) =>
    set(() => ({
      authToken: token,
    })),
  refreshToken: async () => {
    try {
      const newtoken = await generateToken();
      set(() => ({
        authToken: newtoken,
      }));
      return newtoken;
    } catch (error) {
      return false;
    }
  },
}));

export const useUserStore = create<UserStore>((set) => ({
  userdb: null,
  setUserdb: (user: {
    all_agents: boolean;
    cognito_sub: string;
    email: string;
    stripe_id: string;
    username: string;
    _id: string;
  }) =>
    set(() => ({
      userdb: user,
    })),
}));
